import { autoInjectable } from 'tsyringe';
import { EpStore } from '../services/store/ep-store';
import { OverlayService } from '../services/overlay/overlay.service';
import { Analytics } from '../modules/analytics/analytics';
import { CommonEffect } from './common-effect';
import { merge, of } from 'rxjs';
import { ofType } from 'deox';
import { PlacementActions } from '../actions';
import { map, tap } from 'rxjs/operators';

@autoInjectable()
export class TextPlacementEffects implements CommonEffect{

  redirectToUrl$ = this.store.actions$.pipe(
    ofType(PlacementActions.redirectToUrl),
    map(action=>action.payload),
    tap(({targetUrl, target})=>
      window.open(targetUrl, target)
    )
  );

  constructor(private store?: EpStore,
              private overlayService?: OverlayService,
              private analytics?: Analytics){
  }

  bindSideEffects(){
    return merge(
      this.redirectToUrl$,
    ).subscribe();
  }
}
